import { Directive, ElementRef, Input, OnChanges, OnDestroy, Renderer2, SimpleChanges } from '@angular/core';

@Directive({ selector: '[appHighlightOnChange]' })
export class HighlightOnChangeDirective implements OnChanges, OnDestroy {
    @Input() appHighlightOnChange: unknown;
    @Input() highlightContext: unknown;

    private timer: ReturnType<typeof setTimeout>;

    constructor(
        private elementRef: ElementRef<HTMLElement>,
        private renderer: Renderer2,
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        const valueChange = changes.appHighlightOnChange;
        if (changes.highlightContext) {
            this.clearHighlight();
            return;
        }
        if (!valueChange || valueChange.firstChange) {
            return;
        }

        this.clearHighlight();
        // Force layout so another update restarts the animation while it is still running.
        void this.elementRef.nativeElement.offsetWidth;
        this.renderer.addClass(this.elementRef.nativeElement, 'highlighted-field');
        this.timer = setTimeout(() => this.clearHighlight(), 5000);
    }

    ngOnDestroy(): void {
        this.clearHighlight();
    }

    private clearHighlight(): void {
        clearTimeout(this.timer);
        this.renderer.removeClass(this.elementRef.nativeElement, 'highlighted-field');
    }
}
